import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const researchApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetResearch();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (research: CreDtos.Research) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostResearch();
        query.research = research;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/research.service.ts